<ng-container *ngIf="profileError">
    <div class="container py-4">
        <div class="alert alert-warning mb-0">{{ profileError }}</div>
    </div>
</ng-container>

<ng-container *ngIf="!profileError && !profileLoaded">
    <div class="container py-4 text-muted">Loading profile {{ '@' + previewAccountHandle }}…</div>
</ng-container>

<ng-container *ngIf="profileLoaded && !profileError">
    <div class="container-fluid container-md">
        <div class="row">
            <div class="col-sm-2 col-md-3 d-flex flex-column text-sm-end text-md-start align-items-lg-start left_sidebar border-end">
                <app-left-sidebar [Username]="Username"
                                  (postSubmitComplete)="onPostEditedOrDeleted()"
                                  (postContent)="updatePostContent($event)"
                                  (mediaUrlsChange)="updatePostMediaUrls($event)"
                                  (replyTypeChange)="updateReplyType($event)"
                                  (onSave)="savePost()">
                </app-left-sidebar>
            </div>

            <div class="col-12 col-sm-10 col-md-9 col-lg-6 main_bar">
                <div class="row d-flex justify-content-between align-items-center ps-1">
                </div>
                <div class="row mt-4">
                    <div class="col pt-2">
                        <p class="text-muted small ps-1 mb-2">
                            Preview: latest {{ pageSize }} posts from {{ '@' + previewAccountHandle }} (live API). Composer &quot;Post&quot; does not save. Media mix (images/videos) depends on what that account has posted recently.
                        </p>
                        <div class="row">
                            <div class="col-1 mt-2" style="display:table-cell !important;">
                                <div class="user-avatar-container-top">
                                    <img class="circular-image"
                                         [src]="'api/content/logo?userID=' + UserID"
                                         (error)="onApiLogoError($event)"
                                         alt="">
                                </div>
                            </div>

                            <div class="col-11">
                                <app-post-submit [Username]="Username"
                                                 [UserID]="UserID"
                                                 [pageType]="'postSubmitModal'"
                                                 [mediaUrls]="mediaUrls"
                                                 [selectedReplyType]="selectedReplyType"
                                                 (postContent)="updatePostContent($event)"
                                                 (removeMedia)="removeMediaFromFooter($event)">
                                </app-post-submit>

                                <app-post-footer #footerComponent
                                                 [Username]="Username"
                                                 [UserID]="UserID"
                                                 [hasPostText]="hasPostText"
                                                 [pageType]="'Home'"
                                                 (mediaUrlsChange)="updatePostMediaUrls($event)"
                                                 (replyTypeChange)="updateReplyType($event)"
                                                 (onSave)="savePost()">
                                </app-post-footer>
                            </div>
                        </div>

                        <div *ngIf="postsLoading" class="py-3 text-muted ps-1">Loading posts…</div>
                        <div *ngIf="!postsLoading && postsError" class="alert alert-warning">{{ postsError }}</div>

                        <div *ngIf="!postsLoading && !postsError && UserPostsData.length === 0" class="py-3 text-muted ps-1">
                            No posts returned for this account.
                        </div>

                        <div class="row d-flex justify-content-between align-items-center" *ngIf="!postsLoading && !postsError && UserPostsData.length > 0">
                            <div *ngFor="let postData of UserPostsData; let i = index">
                                <div [id]="'post' + ((currentPage - 1) * pageSize + i)"
                                     class="post-container"
                                     (click)="navigateToPost(postData.UserName, postData.TSID)">
                                    <app-post-detail (postEditedOrDeleted)="onPostEditedOrDeleted()"
                                                     [Username]="Username"
                                                     [UserID]="UserID"
                                                     [postData]="postData"
                                                     [pageType]="'dashboard'">
                                    </app-post-detail>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 d-none d-lg-block">
                <div class="right_side_bar">
                    <div class="sidebar-content">
                        <app-right-sidebar [Username]="Username"
                                           [UserID]="UserID">
                        </app-right-sidebar>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
